import { render, staticRenderFns } from "./faqList.vue?vue&type=template&id=4f4b2e2c&scoped=true&"
import script from "./faqList.vue?vue&type=script&lang=js&"
export * from "./faqList.vue?vue&type=script&lang=js&"
import style0 from "./faqList.vue?vue&type=style&index=0&id=4f4b2e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4b2e2c",
  null
  
)

export default component.exports